import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ContactsResponse,
  DeleteContactRequest,
  DeleteContactResponse,
  HandleContactInviteRequest,
  HandleContactInviteResponse,
  SendContactRequest,
  SendContactResponse,
} from './interfaces';

@Injectable()
export class ContactsApiService {
  readonly #httpClient = inject(HttpClient);

  public getContacts(): Observable<ContactsResponse> {
    return this.#httpClient.get<ContactsResponse>(`contacts`);
  }

  public deleteContact(request: DeleteContactRequest): Observable<DeleteContactResponse> {
    return this.#httpClient.post<DeleteContactResponse>(`contacts/delete`, request);
  }

  public sendContactRequest(request: SendContactRequest): Observable<SendContactResponse> {
    return this.#httpClient.post<SendContactResponse>(`contacts/send-request`, request);
  }

  public handleContactRequest(
    request: HandleContactInviteRequest,
  ): Observable<HandleContactInviteResponse> {
    return this.#httpClient.post<HandleContactInviteResponse>(`contacts/handle-request`, request);
  }
}
